import type { PreferenceFieldWithKey } from '@shared/dream-components';

import type { OrganizationSubscription } from '~/interfaces/subscriber_preferences';

/**
 * Transforms organization subscriptions to the True/False preference fields
 * @param organizationSubscriptions - Organization subscriptions
 * @returns Preference fields
 */
const transformOrganizationSubscriptions = (
  organizationSubscriptions: OrganizationSubscription[],
): PreferenceFieldWithKey[] => {
  return organizationSubscriptions.map((orgSub) => ({
    key: orgSub.publication_id,
    type: 'boolean' as const,
    attrs: {
      data: {
        type: 'publication' as const,
        publication_id: orgSub.publication_id,
        publication_name: orgSub.name,
        value: orgSub.subscribed,
        description: orgSub.description,
        required: false,
      },
    },
  }));
};

export default transformOrganizationSubscriptions;
